export default __webpack_public_path__ + "static/media/10-antonas.4370126c.mp4";